import { IdiomaCalendario } from '../../../domain/IdiomaCalendatio';
import { IdiomaService } from '../../../providers/idioma/idioma.service';
import { Component, OnInit, OnDestroy, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { ServiciosWebServiceProvider } from '../../../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../../providers/entity-manager-provider/entity-manager-provider';
import { Message } from 'primeng/primeng';
import { RutaSugerida, RutaSugeridaIdiomaFormulario } from '../../../domain/RutaSugerida';
import { ActivatedRoute, Router } from '@angular/router';
import * as allSettled from 'promise-all-settled';
import { ConfirmationService } from 'primeng/api';
import { Contenido } from '../../../domain/Contenido';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { Idioma } from '../../../domain/Idioma';
import {TranslateService} from 'ng2-translate';
import { ImageCropperComponent, CropperSettings } from 'ngx-img-cropper';
import { Constantes } from '../../../domain/constantes';
import { PermisosService, Permisos } from '../../../providers/authentication/permisos.service';
import { Predicate } from 'breeze-client';
import { AppComponent } from '../../../app.component';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Console } from 'console';


const FILTRO_INI = JSON.stringify({
	where: {
		Titulo: '',
		estado: 4,
		// expirado: new Predicate('FechaAlta', '>=', '1900-01-01'),
		Desde: '',
		Hasta: '',
		ElementoAsignado: '',
		IdAlternativo: '',
		Tipologia: ''
	},
	order: 'Titulo DESC',
	top: 10,
	page: 0,
	total: 0
});
// Necesario para mostrar mensajes con esta plantilla
@Component({
	templateUrl: './nueva.rutaSugerida.component.html',
	providers: [ConfirmationService],
	selector: 'child-component',
	// , declarations: [ImageCropperComponent]
})

export class NuevaRutaSugeridaComponent implements OnInit, OnDestroy {

	@ViewChild('dt_asignados') dt_asignados;
	@ViewChild('dt_no_asignados') dt_no_asignados;
	@ViewChild('pg_no_asignados') pg_no_asignados;



	spinner: HTMLElement;
	edicion: boolean;
	msgsContenidos: Message[] = [];
	msgs: Message[] = [];
	msgFoto: Message[] = [];
	msgAsignarContenido: Message[] = [];
	idRuta: string = null;
	triggerPageChange: boolean = true;

	public filtro = JSON.parse(FILTRO_INI);

	imagenSeleccionada: any;
	rutaSeleccionada: RutaSugerida = new RutaSugerida();

	contenidosTodos: Contenido[] = [];
	contenidosFiltrados: Contenido[] = [];
	contenidoSeleccionado: any;
	public opcion_desde_selected;
	public opcion_hasta_selected;
	/* Validacion */
	public isValid = true;
	public nombreError = false;
	public fAltaError = false;
	public fBajaError = false;
	public imagenError = false;


	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	mapRutaIdioma:  Map<String, RutaSugerida>; // Mapa con la misma noticia pero en distintos idiomas.
	idiomaCalendario: IdiomaCalendario;

	/* COLUMNAS TABLAS */
	colsTodos: any[] = [];
	colsAsignados: any[] = [];

	public displayDialog: boolean = false;
	public apareceBoton: boolean = false;


	/* IMAGE CROPPER*/
	data: any;
	cropperSettings: CropperSettings;
	imageCropperVisible = false;

	@ViewChild('cropper', undefined)
	cropper: ImageCropperComponent;

	public permisos: Permisos = new Permisos();

	@Input() permiteContenidos: boolean = false;
	@Input() visible: boolean = true;
	public mensajesExpirados: any = [
		{
		 	tipo: 'TODOS',
		 	value: 4,
		 	clases: [],
		 	label: 'Contenidos.estadoTodos'
		},
		{
			tipo: 'PROXIMOACT',
			value: 5,
			clases: [],
			label: 'Contenidos.estadoProximoAct'
		},
		{
			tipo: 'ACTIVO',
			value: 3,
			clases: ['ui-message', 'ui-corner-all'],
			label: 'Contenidos.estadoActivo'
		},
		{
			tipo: 'PROXIMO',
			value: 1,
			clases: ['ui-message', 'ui-messages-warning', 'ui-corner-all'],
			label: 'Contenidos.estadoProximo'
		},
		{
			tipo: 'EXPIRADO',
			value: 0,
			clases: ['ui-message', 'ui-messages-error', 'ui-corner-all'],
			label: 'Contenidos.estadoExpirado'
		}

	];

	public mensajesExpiradosMod = this.mensajesExpirados[0];
	public tipologiasContenido = [		{
		tipo: 'TODOS',
		value: 'TODOS',
		clases: [],
		label: 'Todos'
	}];
	public tipologiasContenidoSeleccionada = this.tipologiasContenido[0];
	fechaAlta_DesdeFiltes: any;
	fechaAlta_HastaFiltes: any;

	/*menuLateralModel: any = [];

	private menuSource = new BehaviorSubject(this.menuLateralModel);
	currentMenu = this.menuSource.asObservable();

	changeRuta(ruta){
		this.menuSource.next(ruta);
	}*/

	constructor(
		private appComponent: AppComponent,
		private router: Router,
		private route: ActivatedRoute,
		private entityManager: EntityManagerProvider,
		public authService: AuthenticationService,
		public sws: ServiciosWebServiceProvider,
		private confirmationService: ConfirmationService,
		private breadcrumbService: BreadcrumbService,
		private idiomaService: IdiomaService,
		public translate: TranslateService,
		private permisosService: PermisosService

	) {

		this.filtro = this.authService.getFiltroContenido();
		this.filtro.where.expirado = new Predicate('FechaAlta', '>=', '1900-01-01');

		this.cropperSettings = new CropperSettings();
		this.cropperSettings.width = 400;
		this.cropperSettings.height = 400;
		this.cropperSettings.croppedWidth = 400;
		this.cropperSettings.croppedHeight = 400;
		this.cropperSettings.canvasWidth = 400;
		this.cropperSettings.canvasHeight = 400;
		this.cropperSettings.noFileInput = true;
		this.cropperSettings.fileType = "image/webp";
		this.cropperSettings.minWithRelativeToResolution = true;

		this.data = {};

		this.breadcrumbService.setItems([
			{ label: this.translate.instant('RutasSugeridas.rutassugeridas'), routerLink: ['/rutas-sugeridas'] },
			{ label: this.translate.instant('RutasSugeridas.detalle') }
		]);

		this.route.params
		.subscribe(params => {
			this.idRuta = params['id'];
		});

		this.colsAsignados = [
			{ field: 'Drag', header: '' },
			{ field: 'Imagen', header: this.translate.instant('RutasSugeridas.imagen') },
			{ field: 'Titulo', header: this.translate.instant('RutasSugeridas.nombre') },
			{ field: 'Descripcion', header: this.translate.instant('RutasSugeridas.descripcion') },
			{ field:'FechaAlta', header:this.translate.instant('Formularios.fechaalta')},
			{ field:'FechaBaja', header:this.translate.instant('Formularios.fechabaja')},
			{ field: 'Seccion', header: this.translate.instant('RutasSugeridas.Seccion') },
			{ field: 'MostrarEdicion', header: '' }
		];

		this.colsTodos = [
			{ field: 'Imagen', fieldSort: '', header: this.translate.instant('Contenidos.imagen')}, // clases: ['th-tipo-corto1']},
			{ field: 'Titulo', fieldSort: 'Titulo', header: this.translate.instant('Contenidos.titulo')}, // clases: ['th-tipo-normal'] },
			{ field: 'expirado', fieldSort: 'expirado', header: this.translate.instant('Contenidos.estado')}, // clases: ['th-tipo-corto2'] },
			{ field: 'IdAlternativo', fieldSort: 'IdAlternativo', header: this.translate.instant('Contenidos.idAlternativo')}, // clases: ['th-tipo-medio'] },
			{ field: 'TIPOLOGIA_CONTENIDO', fieldSort: 'Tipologia', header: this.translate.instant('Contenidos.tipologia')}, // clases: ['th-tipo-medio'] },
			{ field: 'MostrarEdicion', fieldSort: '', header: '' }
		];

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');

		this.rutaSeleccionada = new RutaSugerida();
		this.mapRutaIdioma = new Map<String, RutaSugerida>();

		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';
	}
	getMensajesExpirados(_val) {
		for (const i in this.mensajesExpirados) {
			if (this.mensajesExpirados[i].value === _val) {
				return this.mensajesExpirados[i];
			}
		}
		return {};
	}

	ngOnInit() {
		const that = this;
		window.scroll(0, 0);
		// Mostramos Spinner
		this.spinner.style.display = 'inherit';

		const _filtroSaved = this.authService.getFiltroContenido();

		if (_filtroSaved){
			this.filtro = _filtroSaved;
		}

		this.entityManager.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.rutaSeleccionada.Idiomas = that.idiomaService.newMapRutaSugeridaIdiomas(that.idiomas);
			that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;

			return that.cargarContenidos();
		})
		.then(function(){
			console.log('cargarDatos ok');

			if (that.idRuta !== null && that.idRuta !== '' && that.idRuta !== undefined) {
				that.edicion = true;
				return that.cargarRuta();
			}

		})
		.then(function(){

			if (that.rutaSeleccionada.ENTIDAD) {
				that.rutaSeleccionada.Idiomas = that.idiomaService.getMapRutaSugeridaIdiomas(that.rutaSeleccionada.ENTIDAD.IDIOMAS);
			}
			if(that.rutaSeleccionada.FechaBaja !== null && that.rutaSeleccionada.FechaBaja !== ""){
				that.permiteContenidos = true;
				that.apareceBoton = false;
			}
			else{
				that.permiteContenidos = false;
				that.apareceBoton = false;
			}
			// ASIGNADOS
			let value = '';
			let matchMode = '';
			if (that.dt_no_asignados.filters && that.dt_no_asignados.filters.global) {
				value = that.dt_no_asignados.filters.global.value;
				matchMode = that.dt_no_asignados.filters.global.matchMode;
			}

			that.dt_no_asignados.reset();

			if (that.dt_no_asignados.filters && that.dt_no_asignados.filters.global) {
				that.dt_no_asignados.filterGlobal(value, matchMode);
			}

			// NO ASIGNADOS
			if (that.dt_asignados.filters && that.dt_asignados.filters.global) {
				value = that.dt_asignados.filters.global.value;
				matchMode = that.dt_asignados.filters.global.matchMode;
			}

			that.dt_asignados.reset();

			if (that.dt_asignados.filters.global && that.dt_asignados.filters.global.value) {
				that.dt_asignados.filterGlobal(value, matchMode);
			}

			return true;
		})
		.then(function () {
			return that.comprobarPermisos();
		})
		.then(function () {
			return that.permisosService.obtenerTIPOLOGIA_CONTENIDO();
		})
		.then(function (e) {
			that.tipologiasContenido = e;
			that.spinner.style.display = 'none';
		})
		.catch(function (err) {
			console.log('Error cargarDatos: ' + err);
			that.spinner.style.display = 'none';
		});

	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm: Permisos){
			that.permisos = perm;
		});
	}

/* TABLA ASIGNACION CONTENIDO */
	onInputSearchChange(){
		const _where = this.filtro.where;
		this.filtro = JSON.parse(FILTRO_INI);
		this.filtro.where = _where;
		this.cargarContenidos();
	}

	filterTipologia(TIPOLOGIA_CONTENIDO){
		const valorFiltrado = TIPOLOGIA_CONTENIDO.Nombre;

		this.filtro.where.Tipologia = valorFiltrado;

		this.cargarContenidos();
	}

	filterEstado(filter) {
		this.filtro.where.estado = filter.value;
		this.cargarContenidos();
	}


	onSort(evento) {
		console.log(evento);

		let field = evento.field;
		if (field === 'expirado') {
			field = 'Estado';
			// 	field = 'FechaBaja';

		}

		const sentido = evento.order > 0 ? 'ASC' : 'DESC';

		const actual = field + ' ' + sentido;
		if (actual !== this.filtro.order) {
			this.filtro.order = actual;
			this.cargarContenidos();
		}
	}

	cargarContenidos(exportar?: boolean) {

		const that = this;

		// Mostramos Spinner
		this.spinner.style.display = 'inherit';

		const columnas = [];
		const token = this.authService.getToken();

		const idIdioma = this.idiomaSeleccionado.ENTIDAD.Id;
		const idEspacio = this.authService.getIdEspacio();
		const _elementoAsignado = this.filtro.where['ElementoAsignado'];
		const _titulo = this.filtro.where['Titulo'];
		const _idAlternativo =  this.filtro.where['IdAlternativo'];

		let _tipologia = '';
		if (this.filtro.where.Tipologia && this.translate.instant('Contenidos.estadoTodos') !== this.filtro.where.Tipologia.toString()) {
			_tipologia =  this.filtro.where['Tipologia'];
		}
		let size = 10;
		let first = this.filtro.page * size;

		if (exportar) {
			first = 0;
			size = 1000000000000;
		}

		const orderBy = this.filtro.order.split(' ')[0];
		const order = this.filtro.order.split(' ')[1];

		const _estado =  this.filtro.where.estado;
		const Desde =  this.filtro.Desde;
		const Hasta =  this.filtro.Hasta;

		let ids = [];
		const excluidos = this.rutaSeleccionada.Contenidos.map(c => c.IdContenido);
		let Activos = false;
		if (that.permisos.Gestion_Activos === 2) {
			Activos = true;
		}

		return this.sws.wsBuscarContenidos(token, idEspacio, idIdioma, _titulo, _estado, Desde, Hasta, _idAlternativo, _tipologia, _elementoAsignado, first, size, orderBy, order, excluidos, Activos).toPromise()
		.then(function(resp){
			ids = resp.lista;
			that.filtro.total = resp.total;
			let includes = 'FOTOS, ';
			includes = includes + 'IDIOMAS, ';
			includes = includes + 'ALAS.ALA.IDIOMAS, ';
			includes = includes + 'ESPACIOS.ESPACIO.IDIOMAS, ';
			includes = includes + 'SECCIONES.SECCION.IDIOMAS, ';
			includes = includes + 'TIPOLOGIA_CONTENIDO.IDIOMAS';

			return that.entityManager.getContenidosById(ids, includes, columnas);
		})
		.then(function (data) {
			that.contenidosTodos = [];
			that.contenidosFiltrados = [];

			// Ordenamos los contenidos segun el orsen en el que obtubimos los id ya que el breeze no nos devuelve los contenidos en el orden de los Ids
			data = data.sort(function(a, b){
				return ids.indexOf(a.Id) - ids.indexOf(b.Id);
			});
			data.forEach(cont => {
				try {
					const contenido = new Contenido().fromENTIDAD(cont);
					if (contenido.Imagen === null || contenido.Imagen === undefined || contenido.Imagen === ''){
						contenido.Imagen = that.authService.getFotoPorDefecto();
					}
					that.contenidosTodos.push(contenido);
				}
				catch (ex) {
					that.appComponent.showError(that.translate.instant('MensajesEmergentes.MENSAJE_ERROR_CONTENIDOS_CARGAR'));
				}
			});

			that.contenidosFiltrados = that.contenidosTodos;
			that.dt_no_asignados.reset();

			return true;
		})
		.then(function () {

			// Traducimos Contenidos al idioma seleccionado
			that.contenidosTodos = that.idiomaService.traducirContenidos(that.contenidosTodos, that.idiomaSeleccionado);

			// Ocultamos Spinner
			that.triggerPageChange = false;

			that.pg_no_asignados.paginatorState.page = that.filtro.page;
			that.pg_no_asignados.paginatorState.totalRecords = that.filtro.total;

			that.pg_no_asignados.changePage(that.filtro.page);

			that.spinner.style.display = 'none';
			return that.comprobarPermisos();
		});
	}

	onPageChange(evento) {
		console.log(evento);
		this.filtro.page = evento.page;
		if (this.triggerPageChange){
			this.cargarContenidos();
		}else{
			this.triggerPageChange = true;
		}
	}

/* ******* */
	cargarRuta() {
		const that = this;
		let includes = 'RUTA_has_CONTENIDOS, RUTA_has_CONTENIDOS.CONTENIDO.NODODS.NODO.SECCION, ';
		includes = includes + 'FOTOS, ';
		includes = includes + 'IDIOMAS';
		const promises: any[] = [];

		let ultima;

		return this.entityManager.getRutaById(this.idRuta, includes)
		.then(function (ruta: any) {
			that.rutaSeleccionada.Nombre = ruta.nombre;
			that.rutaSeleccionada.Descripcion = ruta.descripcion;
			that.rutaSeleccionada.FechaAlta = ruta.fecha_alta;
			that.rutaSeleccionada.FechaBaja = ruta.fecha_baja;
			that.rutaSeleccionada.PermiteRuta = ruta.PermiteRuta;
			that.rutaSeleccionada.Imagen = that.authService.getFotoPorDefecto();
			that.rutaSeleccionada.ENTIDAD = ruta;

			const RUTA_has_CONTENIDOSsortedArray: any[] = that.rutaSeleccionada.ENTIDAD.RUTA_has_CONTENIDOS.sort((n1, n2) => {
				if (n1.Orden > n2.Orden) {
					return 1;
				}

				if (n1.Orden < n2.Orden) {
					return -1;
				}

				return 0;
			});

			console.log(RUTA_has_CONTENIDOSsortedArray);

			RUTA_has_CONTENIDOSsortedArray.forEach(ruta_has_contenido => {
				const contenido = new Contenido().fromENTIDAD(ruta_has_contenido.CONTENIDO);
				if (contenido.Imagen === null || contenido.Imagen === undefined || contenido.Imagen === ''){
					contenido.Imagen = that.authService.getFotoPorDefecto();
				}
				that.asignarContenido(contenido);
			});

			that.spinner.style.display = 'none';

			ultima = that.rutaSeleccionada.ENTIDAD.FOTOS.length - 1;

			if (ultima >= 0) {
				if (that.rutaSeleccionada.ENTIDAD.FOTOS[ultima].UrlFotoExt) {
					that.rutaSeleccionada.Imagen = that.rutaSeleccionada.ENTIDAD.FOTOS[ultima].UrlFotoExt;
				}
				else{
					that.rutaSeleccionada.Imagen =  environment.urlBaseFotos +  that.rutaSeleccionada.ENTIDAD.FOTOS[ultima].IdFotoExt;
				}
			}
			else {
				that.rutaSeleccionada.Imagen = that.authService.getFotoPorDefecto();
			}

		})
		.catch(function (e) {
			console.log(e);
			that.appComponent.showError(e.message);
			return false;
		});
	}

	/* DropDown */
	onIdiomaChange($event){
		const idioma = $event.value;
		if (!idioma) {
			return;
		}
		this.idiomaSeleccionado = idioma;

		// Cojemos la traduccion del espacio al idioma seleccionado
		let rutaSugeridaIdioma = this.rutaSeleccionada.Idiomas.get(idioma.value);

		// Si no existe la creamos
		if (!rutaSugeridaIdioma) {
			rutaSugeridaIdioma = new RutaSugeridaIdiomaFormulario();
			this.rutaSeleccionada.Idiomas.set(idioma.value, rutaSugeridaIdioma);
		}

		// Seteamos los valores de espacioFormulario con los valores del idioma seleccionado
		this.rutaSeleccionada.Nombre = rutaSugeridaIdioma.Nombre;
		this.rutaSeleccionada.Descripcion = rutaSugeridaIdioma.Descripcion;

		console.log('Cambiar Titulo y descripcion a la del idioma: ' + idioma.value + '(' + idioma.title + ')');
	}

	/* ************************************************************************** */
	/*                            COMUN FORMULARIO                                */
	/* ************************************************************************** */

	/* Validar */
	inputChanged(value) {
		if(value === 'fecha_baja'){
			if(this.rutaSeleccionada.FechaBaja !== null){
				this.permiteContenidos = true;
				this.apareceBoton = false;
			}
			else{
				this.permiteContenidos = false;
				this.apareceBoton = false;
			}

		}
		const p1Error = this.rutaSeleccionada.Nombre === '' || this.rutaSeleccionada.Nombre === undefined;
		const p2Error = this.rutaSeleccionada.FechaAlta === '' || this.rutaSeleccionada.FechaAlta === undefined || this.rutaSeleccionada.FechaAlta === null;
		const p3Error = false; // this.rutaSeleccionada.FechaBaja === ''  || this.rutaSeleccionada.FechaBaja === undefined  || this.rutaSeleccionada.FechaBaja === null
		const p4Error = false; // this.rutaSeleccionada.Imagen === undefined && this.imagenSeleccionada === undefined;

		// Validacion al guardar
		if (value === 'obligatorio'){
			if (p1Error) {
				this.nombreError = true;
			}
			else {
				this.nombreError = false;
			}

			if (p2Error) {
				this.fAltaError = true;
			}
			else {
				this.fAltaError = false;
			}

			if (p3Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}

			if (p4Error) {
				this.imagenError = true;
			}
			else {
				this.imagenError = false;
			}
		}
		// validacion al editar titulo
		else if (value === 'nombre'){
			if (p1Error) {
				this.nombreError = true;
			}
			else {
				this.nombreError = false;
			}
		}
		// validacion al editar fecha_alta
		else if (value === 'fecha_alta'){
			if (p2Error) {
				this.fAltaError = true;
			}
			else {
				this.fAltaError = false;
			}
		}
		// validacion al editar fecha_baja
		else if (value === 'fecha_baja'){
			if (p3Error) {
				this.fBajaError = true;
			}
			else {
				this.fBajaError = false;
			}
		}

		//  Cojemos la traduccion del espacio al idioma seleccionado
		const rutaSugeridaIdioma = this.rutaSeleccionada.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);
		if(rutaSugeridaIdioma !== undefined){
				// Guardamos los posibles cambios del idioma
				rutaSugeridaIdioma.Nombre = this.rutaSeleccionada.Nombre;
				rutaSugeridaIdioma.Descripcion = this.rutaSeleccionada.Descripcion;
				this.rutaSeleccionada.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, rutaSugeridaIdioma);
		}


	}

	public validar(): boolean {
		this.inputChanged('obligatorio');
		const p1 = this.nombreError;
		const p2 = this.fAltaError;
		const p3 = false; // this.fBajaError;
		const p4 = this.imagenError;

		if (p1 || p2 || p3) {
			this.isValid = false;
			if (p4) {
				if (this.imagenError) {
					this.msgFoto.push({severity: 'error', summary: this.translate.instant('RutasSugeridas.imagenobligatoria'), detail: this.translate.instant('RutasSugeridas.elegirimagen')});
				}
			}
		}
		else {
			this.isValid = true;
		}

		return this.isValid;
	}

	public esEdicion(): boolean {
		return this.edicion;
	}

	cancelar(){
		this.confirmationService.confirm({
            message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_CANCELAR'),
            accept: () => {
				this.router.navigate(['/rutas-sugeridas']);
			},
			reject: () => {
				console.log('Cancelado el Cancelado de Ruta Sugerida.');
			}
        });
	}

	volver(){
		this.router.navigate(['/rutas-sugeridas']);
	}
	public guardar(): any {
		if(this.rutaSeleccionada.FechaBaja === ''){
			this.apareceBoton = false;
			this.permiteContenidos =false
			this.guardarSinBajaContenidos();
		}
		else if(this.rutaSeleccionada.FechaBaja !== null){
			if(this.apareceBoton === false){
				//this.apareceBoton = true;
				this.guardarConBotonBajaContenidos();
			}
			else{
				//this.apareceBoton = true;
				this.desactivarRutaSugeridaConContenidos();
			}
		}
		else{
			this.apareceBoton = false;
			this.permiteContenidos === false
			this.guardarSinBajaContenidos();
		}
	}
	public guardarConBotonBajaContenidos(): any{
		this.confirmationService.confirm({
            message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_MODIFICAR_CONTENIDOS'),
            accept: () => {
				if (this.validar()) {
					this.spinner.style.display = 'inherit';
					if (!this.esEdicion()) {
						this.guardarBD(true);
					}
					else {
						this.guardarBD(false);
					}
				} else {
					this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
				}
			},
			reject: () => {
				console.log('Cancelado el Guardado de Contenido.');
			}
        });
	}
	public guardarSinBajaContenidos(): any {

		this.confirmationService.confirm({
            message: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_MODIFICAR'),
            accept: () => {
				if (this.validar()) {
					this.spinner.style.display = 'inherit';
					if (!this.esEdicion()) {
						this.guardarBD(true);
					}
					else {
						this.guardarBD(false);
					}
				} else {
					this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
				}
			},
			reject: () => {
				console.log('Cancelado el Guardado de Contenido.');
			}
        });
	}
	desactivarRutaSugeridaConContenidos(){
		console.log('desactivarRutaSugeridaConContenidos.');
		if (this.validar()) {
			this.spinner.style.display = 'inherit';
			if (!this.esEdicion()) {
				this.guardarBD_CONTENIDOS(true);
			}
			else {
				this.guardarBD_CONTENIDOS(false);
			}
		} else {
			this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
		}

	}
	private setRutaSugerida(RUTA_SUGERIDA){
		const that = this;
		const promises: any[] = [];
		this.rutaSeleccionada.ENTIDAD = RUTA_SUGERIDA;

		return this.guardarMultiIdioma()
		.then(function(){

			const espacioIdioma = that.rutaSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.rutaSeleccionada.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
			that.rutaSeleccionada.Descripcion = espacioIdioma.Descripcion ? espacioIdioma.Descripcion : '';

			RUTA_SUGERIDA.idEspacio = that.authService.getIdEspacio();
			RUTA_SUGERIDA.nombre = that.rutaSeleccionada.Nombre;
			RUTA_SUGERIDA.descripcion = that.rutaSeleccionada.Descripcion;
			RUTA_SUGERIDA.fecha_alta = that.rutaSeleccionada.FechaAlta;
			RUTA_SUGERIDA.fecha_baja = that.rutaSeleccionada.FechaBaja;
			RUTA_SUGERIDA.PermiteRuta = that.rutaSeleccionada.PermiteRuta;
			that.rutaSeleccionada.ENTIDAD = RUTA_SUGERIDA;

			if (that.rutaSeleccionada.Contenidos.length > 0) {
				that.rutaSeleccionada.Contenidos.forEach(() => {
					promises.push(that.entityManager.newRUTA_has_CONTENIDO());
				});
			}
			return allSettled(promises);
		});

	}

	guardarMultiIdioma(){
		const that = this;
		this.entityManager.deleteEntityArray(this.rutaSeleccionada.ENTIDAD.IDIOMAS);

		return this.entityManager.newRUTA_SUGERIDA_IDIOMA(this.rutaSeleccionada.ENTIDAD)
		.then(function(RUTA_SUGERIDA_IDIOMAs){

			RUTA_SUGERIDA_IDIOMAs.forEach(RUTA_SUGERIDA_IDIOMA => {
				const aux = that.rutaSeleccionada.Idiomas.get(RUTA_SUGERIDA_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					RUTA_SUGERIDA_IDIOMA.Nombre = aux.Nombre;
					RUTA_SUGERIDA_IDIOMA.Descripcion = aux.Descripcion;
				}

			});

		});
	}
	guardarBD_CONTENIDOS(nuevo?){
		const that = this;
		let promises: any[] = [];

		let rutaProm;

		if (nuevo){
			const rutaSug = this.entityManager.newRUTA_SUGERIDA();
			rutaProm = rutaSug.then(this.setRutaSugerida.bind(this));
		}else{
			if(this.rutaSeleccionada.Contenidos.length !== 0){
				this.rutaSeleccionada.ENTIDAD.RUTA_has_CONTENIDOS.forEach(c =>{
					//console.log("formato fecha baja contenido",c.FechaBaja);
					//console.log("formato fecha baja de la ruta",this.rutaSeleccionada.FechaBaja);

					if(c.CONTENIDO.FechaBaja === null){
						c.CONTENIDO.FechaBaja = this.rutaSeleccionada.FechaBaja;
					}
					let fechaauxDayRuta = new Date(this.rutaSeleccionada.FechaBaja).getDate();
					let fechaauxDayContenido = c.CONTENIDO.FechaBaja.getDate();

					let fechaauxMonthRuta = new Date(this.rutaSeleccionada.FechaBaja).getMonth();
					let fechaauxMonthContenido = c.CONTENIDO.FechaBaja.getMonth();

					let fechaauxYearRuta = new Date(this.rutaSeleccionada.FechaBaja).getFullYear();
					let fechaauxyearContenido = c.CONTENIDO.FechaBaja.getFullYear();

					if( fechaauxyearContenido > fechaauxYearRuta){
						c.CONTENIDO.FechaBaja = this.rutaSeleccionada.FechaBaja;
					}
					else if(fechaauxyearContenido === fechaauxYearRuta){
						if(fechaauxMonthContenido > fechaauxMonthRuta){
							c.CONTENIDO.FechaBaja = this.rutaSeleccionada.FechaBaja;
						}
						else if(fechaauxMonthContenido === fechaauxMonthRuta && fechaauxDayContenido > fechaauxDayRuta){
							c.CONTENIDO.FechaBaja = this.rutaSeleccionada.FechaBaja;
						}

					}
				});
				rutaProm = this.setRutaSugerida(this.rutaSeleccionada.ENTIDAD);
				this.entityManager.deleteEntityArray(this.rutaSeleccionada.ENTIDAD.RUTA_has_CONTENIDOS);
			}
			//rutaProm = this.setRutaSugerida(this.rutaSeleccionada.ENTIDAD);
			//this.entityManager.deleteEntityArray(this.rutaSeleccionada.ENTIDAD.RUTA_has_CONTENIDOS);
		}

		rutaProm.then(function (RUTA_has_CONTENIDOS) {

			for (let index = 0; index < RUTA_has_CONTENIDOS.length; index++) {
				const ruta_has_contenido = RUTA_has_CONTENIDOS[index].result;

				ruta_has_contenido.IdContenido = that.rutaSeleccionada.Contenidos[index].ENTIDAD.Id;
				ruta_has_contenido.IdRutaSugerida = that.rutaSeleccionada.ENTIDAD.Id;
				ruta_has_contenido.Orden = index;


			}

			promises = [];
			return that.entityManager.saveChanges();

		})
		.then(function () {
			return that.subirFotos();
		})
		.then(function () {
			that.appComponent.showSuccess(that.translate.instant('RutasSugeridas.rutaguardadook'));
			that.spinner.style.display = 'inherit';
			that.router.navigate(['/rutas-sugeridas']);
			return that.translate.instant('RutasSugeridas.rutaguardadook');
		})
		.catch(function (e) {
			console.log(e);
			that.spinner.style.display = 'inherit';
			that.appComponent.showError(e.message);
			return false;
		});

	}

	guardarBD(nuevo?){
		const that = this;
		let promises: any[] = [];

		let rutaProm;

		if (nuevo){
			const rutaSug = this.entityManager.newRUTA_SUGERIDA();
			rutaProm = rutaSug.then(this.setRutaSugerida.bind(this));
		}else{
			rutaProm = this.setRutaSugerida(this.rutaSeleccionada.ENTIDAD);
			this.entityManager.deleteEntityArray(this.rutaSeleccionada.ENTIDAD.RUTA_has_CONTENIDOS);
		}
		console.log(this.rutaSeleccionada);
		if(that.rutaSeleccionada.Contenidos.length > 99){
			that.msgs.push({severity: 'error', summary: 'Error', detail: that.translate.instant('RutasSugeridas.limiteContenidoGuardar')});
			that.spinner.style.display = 'none';
		}else{
			rutaProm.then(function (RUTA_has_CONTENIDOS) {
					for (let index = 0; index < RUTA_has_CONTENIDOS.length; index++) {
						const ruta_has_contenido = RUTA_has_CONTENIDOS[index].result;
		
						ruta_has_contenido.IdContenido = that.rutaSeleccionada.Contenidos[index].ENTIDAD.Id;
						ruta_has_contenido.IdRutaSugerida = that.rutaSeleccionada.ENTIDAD.Id;
						ruta_has_contenido.Orden = index;
					}
		
					promises = [];
					return that.entityManager.saveChanges();
	
			})
			.then(function () {
				return that.subirFotos();
			})
			.then(function () {
				that.appComponent.showSuccess(that.translate.instant('RutasSugeridas.rutaguardadook'));
				that.spinner.style.display = 'inherit';
				that.router.navigate(['/rutas-sugeridas']);
				return that.translate.instant('RutasSugeridas.rutaguardadook');
			})
			.catch(function (e) {
				console.log(e);
				that.spinner.style.display = 'inherit';
				that.appComponent.showError(e.message);
				return false;
			});
	

		}

	}

	/* ASIGNACIONES CONTENIDOS */
	asignarContenido(rowData) {
		// Asignamos contenidos
		const idContenido = rowData.ENTIDAD.Id ? rowData.ENTIDAD.Id : rowData.Id;
		if(this.rutaSeleccionada.Contenidos.length >= 99){
			this.msgs.push({severity: 'error', summary: this.translate.instant('RutasSugeridas.limiteContenidoGuardar')});
		}else{
			this.rutaSeleccionada.Contenidos.push(rowData);
			this.contenidosFiltrados = this.contenidosFiltrados.filter(obj => obj.ENTIDAD.Id !== idContenido);
		}

	}

	desasignarContenido(rowData) {

		// Asignamos contenidos
		this.contenidosTodos.push(rowData);
		const idContenido = rowData.ENTIDAD.Id ? rowData.ENTIDAD.Id : rowData.Id;
		this.rutaSeleccionada.Contenidos = this.rutaSeleccionada.Contenidos.filter(obj => obj.ENTIDAD.Id !== idContenido);

		// Reasignamos orden
		for (let index = 0; index < this.rutaSeleccionada.Contenidos.length; index++) {
			const element = this.rutaSeleccionada.Contenidos[index];
			element.Orden = index;
		}

			// ASIGNADOS
			let value = '';
			let matchMode = '';
			if (this.dt_no_asignados.filters && this.dt_no_asignados.filters.global) {
				value = this.dt_no_asignados.filters.global.value;
				matchMode = this.dt_no_asignados.filters.global.matchMode;
			}

			this.dt_no_asignados.reset();

			// if (this.dt_no_asignados.filters && this.dt_no_asignados.filters.global) {
			this.dt_no_asignados.filterGlobal(value, matchMode);
			// }

			// NO ASIGNADOS
			value = '';
			matchMode = '';
			if (this.dt_asignados.filters && this.dt_asignados.filters.global) {
				value = this.dt_asignados.filters.global.value;
				matchMode = this.dt_asignados.filters.global.matchMode;
			}

			this.dt_asignados.reset();

			// if (this.dt_asignados.filters.global && this.dt_asignados.filters.global.value) {
			this.dt_asignados.filterGlobal(value, matchMode);
			// }
	}

	downContenido(rowData, i){
		this.rutaSeleccionada.Contenidos.splice(i, 1);
		this.rutaSeleccionada.Contenidos.splice( i + 1 , 0, rowData);
	}

	upContenido(rowData, i){
		this.rutaSeleccionada.Contenidos.splice(i, 1);
		this.rutaSeleccionada.Contenidos.splice( i - 1 , 0, rowData);
	}

	mostrarEditar(contenido) {
		this.contenidoSeleccionado = contenido;
		contenido.MostrarEdicion = true;
	}

	ocultarEditar(nodo) {
		// this.nodoSeleccionado = undefined;
		nodo.MostrarEdicion = false;
	}

	mostrarAsignarContenido(){
		this.cargarContenidos();
		this.displayDialog = true;
	}


	/* imagen */
	onFileSelect($event) {
		this.msgFoto = [];
		this.imagenSeleccionada = $event.files[0];
	}

	onRemoveSelect(){
		this.imagenSeleccionada = undefined;
	}

	eliminarUploadedFiles() {
		this.onRemoveSelect();
	}

	public subirFotos(){
		// PREPARAMOS LA SUBIDA DE LAS FOTOS
		const promises: any[] = [];
		const that = this;

		if (that.imagenSeleccionada !== undefined) {
			/*
			const ultima = that.rutaSeleccionada.ENTIDAD.FOTOS.length - 1;
			if (ultima >= 0) {
				this.entityManager.deleteEntity(that.rutaSeleccionada.ENTIDAD.FOTOS[ultima]);
			}

			promises.push(that.enviarFoto('IdRutaSugerida', that.rutaSeleccionada.ENTIDAD.Id, that.imagenSeleccionada));
			*/

			let idFoto = null;
			if (that.rutaSeleccionada.ENTIDAD && that.rutaSeleccionada.ENTIDAD.FOTOS) {
				const ultima = that.rutaSeleccionada.ENTIDAD.FOTOS.length - 1;
				const fotoUpdate = that.rutaSeleccionada.ENTIDAD.FOTOS[ultima];
				idFoto = fotoUpdate ? fotoUpdate.Id : null;
			}
			promises.push(that.enviarFoto('IdRutaSugerida', that.rutaSeleccionada.ENTIDAD.Id, that.imagenSeleccionada, idFoto));
		}

		return allSettled(promises);
	}

	enviarFoto(entidad, idEntidad, imagen, idFoto = null) {
		const token = this.authService.getToken();
		if (imagen !== undefined) {
			return this.sws.wsSubidaFoto(token, entidad, idEntidad, imagen, imagen.name, idFoto).toPromise();
		}
	}


	/* Image Cropper */
	fileChangeListener($event) {
		this.imageCropperVisible = true;
		const image: any = new Image();
		const file: File = $event.target.files[0];
		const nombre = file.name;
		const tipo = file.type;
		const myReader: FileReader = new FileReader();
		const that = this;
		myReader.onloadend = function (loadEvent: any) {
			image.src = loadEvent.target.result;
			that.cropper.setImage(image);
			that.sws.base64ToFile(image.src, nombre, tipo)
			.then(function(fotoFile){
				that.imagenSeleccionada = fotoFile;
			});
		};
		myReader.readAsDataURL(file);
	}

	asignarFotoCropp($event){
		const that = this;
		this.sws.base64ToFile(this.data.image, that.imagenSeleccionada.name)
		.then(function(fotoFile){
			that.imagenSeleccionada = fotoFile;
			that.imageCropperVisible = false;
		});
	}


	miFiltro(value, field, filtro){
		console.log(value);
		console.log(field);
		console.log(filtro);
	}

	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (columna === 'fecha_alta') {
			this.rutaSeleccionada.FechaAlta = fecha;
		}
		if (columna === 'fecha_baja') {
			this.rutaSeleccionada.FechaBaja = fecha;
		}
		if (columna === 'FechaAlta' && tipo === 'fechaAlta_DesdeFiltes') {
			this.fechaAlta_DesdeFiltes = fecha;
			dt.filter(fecha, columna, 'gt')

		}
		if (columna === 'FechaBaja' && tipo === 'fechaAlta_HastaFiltes') {
			this.fechaAlta_HastaFiltes = fecha;
			dt.filter(fecha, columna, 'gt')
		}


		this.inputChanged(columna);
		calendar.overlayVisible=false;
	}
}





// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/RutasSugeridas/nuevo/nueva.rutaSugerida.component.ts